import { render, staticRenderFns } from "./orderItemImportDialog.vue?vue&type=template&id=311efcf3&"
import script from "./orderItemImportDialog.vue?vue&type=script&lang=js&"
export * from "./orderItemImportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports